import { createApp } from 'vue';
import TlntD1PTable from '../../talent/D1PTable.vue'
const appElements = document.querySelectorAll('.vue-tlnt-render-d1')

Array.from(appElements).forEach(element => {
  createApp(TlntD1PTable).mount(element);
});
